import MD5 from 'crypto-js/md5';
import { deepClone } from 'utils';
// import { getSyncedTime } from './networkTime';
// uuid
import { v4 as uuidv4 } from 'uuid';

// 获取指定位数的随机数
function getRandom(num: number) {
    return Math.floor((Math.random() + Math.floor(Math.random() * 9 + 1)) * Math.pow(10, num - 1));
}

function genSign(obj: any) {
    const params: any = deepClone(obj);

    // 密钥
    const secret = '9ALalE51IJxxkK0Pg0ejgbwYvM2sUaGf';
    // 10位时间戳 - 使用网络同步时间
    // const syncedTime = getSyncedTime();
    // const timestampStr = parseInt(String(syncedTime / 1000)).toString();
    const timestampStr = parseInt(String(new Date().getTime() / 1000)).toString();

    // 20位随机数
    // const nonce = '89199680690019100000';
    // const nonce = getRandom(20).toString();
    const nonce = uuidv4();
    // params.timestampStr = timestampStr;
    params.nonce = nonce;

    // 取 key
    const sortedKeys = [];
    for (const key in params) {
        // 注意这里，要剔除掉 sign 参数本身
        if (key !== 'sign') {
            // @ts-ignore
            sortedKeys.push(key);
        }
    }
    // 参数名 ASCII 码从小到大排序（字典序）
    sortedKeys.sort();

    // 1 拼接参数
    let str = '';
    sortedKeys.forEach(key => {
        const value = params[key];
        // 如果值是数组，使用 JSON.stringify 保持 JSON 格式
        const valueStr = Array.isArray(value) ? JSON.stringify(value) : value;
        str += key + valueStr;
    });
    // console.log('str: ', str);

    // 2 拼接密钥
    str += secret;

    // 3 MD5加密
    // params.sign = MD5(str).toString().toUpperCase();

    // 9ALalE51IJxxkK0Pg0ejgbwYvM2sUaGf
    // if (obj?.paymentName === 'RupeeRush') {
    //     console.log('str: ', str);
    //     console.log('MD5加密: ', MD5(str).toString().toUpperCase());
    // }

    // console.log('str: ', str);
    // console.log('MD5加密: ', MD5(str).toString().toUpperCase());
    // console.log('时间戳:', timestampStr);

    return {
        sign: MD5(str).toString().toUpperCase(),
        timestampStr,
        nonce,
    };
}

export default genSign;
